import styled from 'styled-components'

export const ModalShadow = styled.div`
	position: absolute;
	inset: 0;
`
